import styled from "styled-components";
import { AutoComplete } from "antd";
import color from "../_style/color";

export default styled(AutoComplete).attrs({
  dropdownStyle: { border: `1px solid ${color.gainsboro}`, boxShadow: "unset" },
  filterOption: false,
})`
  width: 100%;
  cursor: auto;
  margin-top: 10px;

  .ant-input-affix-wrapper:hover,
  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper-focused {
    border: 1px solid ${color.gainsboro};
    box-shadow: unset;
  }
`;
